import Repository from "@/repositories/Repository";

const resource = "/messages";
export default {
	get(params: any) {
		return Repository.get(`${resource}`, {
			params: {
				...params,
			},
		});
	},
	createPost(params: any) {
		return Repository.post(`${resource}`, params);
	},
	// getPost(postId: any) {
	// 	return Repository.get(`${resource}/${postId}`);
	// },
};
